import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=a781f7c0&scoped=true&"
import script from "./EmptyCart.vue?vue&type=script&lang=js&"
export * from "./EmptyCart.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCart.vue?vue&type=style&index=0&id=a781f7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a781f7c0",
  null
  
)

export default component.exports